import clsx from "clsx";
import React from "react";
import { peerReviewText } from "../../../formatters";
import { EvidenceIcon } from "../evidence-icon";

interface Props {
  reviewed: boolean;
}

export function ReviewedBar({ reviewed }: Props) {
  return (
    <div
      className={clsx(" w-full overflow-hidden rounded flex mt-6 mb-12", {
        "bg-green": reviewed === true,
        "bg-red-default": !reviewed,
      })}
    >
      <div className="flex flex-3 text-white justify-center items-center p-6">
        <span className="text-lg">{peerReviewText(reviewed)}</span>
        <EvidenceIcon
          reviewed={reviewed}
          className="h-6 w-6 white-icon ml-2"
        />
      </div>
    </div>
  );
}
